export { default as useResizeObserver } from 'use-resize-observer';
import { useRect } from '@reach/rect';
import { useMediaQuery } from 'react-responsive';
import { uuid } from '@deseretbook/utils';
import React, { useState, useRef, useEffect } from 'react';

var _extends = Object.assign || function (a) {
  for (var b, c = 1; c < arguments.length; c++) {
    for (var d in b = arguments[c], b) {
      Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
    }
  }

  return a;
},
    slicedToArray = function () {
  function a(a, b) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        !d && h['return'] && h['return']();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }

  return function (b, c) {
    if (Array.isArray(b)) return b;
    if (Symbol.iterator in Object(b)) return a(b, c);
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
  };
}(),
    toConsumableArray = function toConsumableArray(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) {
      c[b] = a[b];
    }

    return c;
  }

  return Array.from(a);
},
    useDropdown = function useDropdown() {
  var a = useState(!1),
      b = slicedToArray(a, 2),
      c = b[0],
      d = b[1],
      e = useRef(null),
      f = useRect(e),
      g = useRef(uuid()),
      h = function h() {
    d(!1);
  },
      i = {
    "aria-controls": g.current,
    role: 'button',
    "aria-haspopup": 'true',
    "aria-expanded": c,
    ref: e,
    onClick: function onClick() {
      return d(!c);
    }
  },
      j = {
    isOpen: c,
    role: 'menu',
    id: g.current,
    triggerRect: f,
    triggerRef: e,
    close: h
  };

  return {
    triggerProps: i,
    dropdownProps: j,
    isOpen: c,
    open: function open() {
      d(!0);
    },
    close: h
  };
};

'undefined' != typeof window && require('intersection-observer');

var intersectionObserverReducer = function intersectionObserverReducer(a, b) {
  var c = b.action,
      d = b.payload;

  switch (c) {
    case 'SUBSCRIBE':
      return _extends({}, a, {
        refs: [].concat(toConsumableArray(a.refs), [d.ref]),
        callbacks: [].concat(toConsumableArray(a.callbacks), [d.callback])
      });

    case 'UNSUBSCRIBE':
      {
        var e = a.refs.findIndex(function (a) {
          return a.current === d.ref.current;
        });
        return 0 > e ? a : _extends({}, a, {
          refs: [].concat(toConsumableArray(a.refs.slice(0, e)), toConsumableArray(a.refs.slice(e + 1))),
          callbacks: [].concat(toConsumableArray(a.callbacks.slice(0, e)), toConsumableArray(a.callbacks.slice(e + 1)))
        });
      }

    default:
      return a;
  }
},
    useIntersectionObserver = function useIntersectionObserver() {
  var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      b = React.useReducer(intersectionObserverReducer, {
    refs: [],
    callbacks: []
  }),
      c = slicedToArray(b, 2),
      d = c[0],
      e = d.refs,
      f = d.callbacks,
      g = c[1],
      h = React.useCallback(function () {
    var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
        b = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : function () {};
    g({
      action: 'SUBSCRIBE',
      payload: {
        ref: a,
        callback: b
      }
    });
  }, [g]),
      i = React.useCallback(function () {
    var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    g({
      action: 'UNSUBSCRIBE',
      payload: {
        ref: a
      }
    });
  }, [g]),
      j = React.useCallback(function (a) {
    a.forEach(function (a) {
      var b = e.findIndex(function (b) {
        return b.current === a.target;
      });
      'function' == typeof f[b] && f[b](a);
    });
  }, [e, f]);
  return React.useEffect(function () {
    if (!window || !window.IntersectionObserver) return function () {};
    var b = new window.IntersectionObserver(j, {
      root: a.rootRef && a.rootRef.current,
      rootMargin: a.rootMargin,
      threshold: a.threshold
    });
    return e.forEach(function (a) {
      try {
        b.observe(a.current);
      } catch (a) {}
    }), function () {
      return b.disconnect();
    };
  }, [a, e, j]), {
    subscribe: h,
    unsubscribe: i
  };
},
    useMediaQuery$1 = function useMediaQuery$1(a, b, c) {
  return useMediaQuery('number' == typeof a ? {
    minWidth: a
  } : a, 'number' == typeof b ? {
    deviceWidth: b
  } : b, c);
},
    useOnClickOutside = function useOnClickOutside(a, b) {
  var c = Array.isArray(a) ? a : [a];
  useEffect(function () {
    var a = function a(_a) {
      c.some(function (b) {
        return !b.current || b.current.contains(_a.target);
      }) || b(_a);
    };

    return document.addEventListener('mousedown', a), document.addEventListener('touchstart', a), function () {
      document.removeEventListener('mousedown', a), document.removeEventListener('touchstart', a);
    };
  }, [c, b]);
},
    usePopup = function usePopup() {
  var a = useState(!1),
      b = slicedToArray(a, 2),
      c = b[0],
      d = b[1],
      e = useRef(uuid()),
      f = function f() {
    d(!1);
  },
      g = {
    "aria-controls": e.current,
    role: 'button',
    "aria-haspopup": 'true',
    "aria-expanded": c,
    onClick: function onClick() {
      return d(!c);
    }
  },
      h = {
    isOpen: c,
    role: 'menu',
    id: e.current,
    "aria-modal": 'true',
    "aria-hidden": !c,
    close: f
  };

  return {
    triggerProps: g,
    popupProps: h,
    isOpen: c,
    open: function open() {
      d(!0);
    },
    close: f
  };
},
    useDelay = function useDelay(a, b) {
  var c = useState(null),
      d = slicedToArray(c, 2),
      e = d[0],
      f = d[1];
  return function (c) {
    clearTimeout(e), f(setTimeout(function () {
      b(c);
    }, a));
  };
};

export { useDropdown, useIntersectionObserver, useMediaQuery$1 as useMediaQuery, useOnClickOutside, usePopup, useDelay };